import { Grid } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import ApartmentIcon from '@material-ui/icons/Apartment';
import React from 'react';
import { useSelector } from 'react-redux';
import CardMessage from '../../../components/CardMessage/CardMessage';
import { AppState } from '../../../store';
import { CondominiumReducerData } from '../../../store/reducers/condominiumReducer';
import EmployeesListCard from '../../../components/EmployeesListCard';
import GeolocationDetailCard from './components/GeolocationDetailCard';
import PhotoHistoryCard from './components/PhotoHistoryCard';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainContentContainer: {
      overflowX: 'hidden',
      display: 'flex',
      alignItems: 'center',
      overflowY: 'auto',
      margin: 0,
      width: '100%',
      height: 'calc(100vh - 152px)',
      padding: theme.spacing(1),
    },

    contentMaxHeight: {
      height: '100%',
    },
  }),
);

const GeolocationCard: React.FC = () => {
  const classes = useStyles();

  const { condominiumSelected }: CondominiumReducerData = useSelector(
    (state: AppState) => state.condominiumReducer,
  );

  return (
    <Grid className={classes.mainContentContainer} spacing={2} container>
      {condominiumSelected ? (
        <>
          <Grid
            className={classes.contentMaxHeight}
            item
            xs={12}
            sm={12}
            md={3}
          >
            <EmployeesListCard
              title="Funcionários"
              titleTooltip="Clique no nome do funcionário para ver seu histórico de localização"
              selectableItemList
              hideAllActionButtonsDefault
            />
          </Grid>
          <Grid
            className={classes.contentMaxHeight}
            item
            xs={12}
            sm={12}
            md={6}
          >
            <GeolocationDetailCard />
          </Grid>
          <Grid
            className={classes.contentMaxHeight}
            item
            xs={12}
            sm={12}
            md={3}
          >
            <PhotoHistoryCard />
          </Grid>
        </>
      ) : (
        <CardMessage
          icon={<ApartmentIcon style={{ fontSize: 130, opacity: 0.4 }} />}
          message="Selecione um condomínio"
        />
      )}
    </Grid>
  );
};

export default GeolocationCard;
